/**
 * Landing page API service
 */
import axios from 'axios';
import type { LandingPageData } from '../types';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export const landingApi = {
    /**
     * Fetch landing page content
     */
    async getHomeContent(): Promise<LandingPageData> {
        const response = await axios.get<LandingPageData>(`${API_URL}/landing/home`);
        return response.data;
    }
};
